import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
//style
import styles from 'src/asset/scss/style/market.detail.module.scss';
//bottomSheet
import { BottomSheet } from 'react-spring-bottom-sheet';
//import 'react-spring-bottom-sheet/dist/style.css';
import 'src/asset/scss/plugin/bottomsheet/style.scss';
import 'src/asset/scss/plugin/bottomsheet/bottomsheet.scss';
//hook
import useMarketHook from 'src/webapp/hooks/market/market.hook';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function MarketUpdate(props) {
    const params = useParams();
    const navigator = useNavigate();
	const { data, isOpen } = props;//props
    
    const { marketUpdateAndDeleteAPI } = useMarketHook();
    /* =============== 게시글 버튼목록 =============== */
    const buttonList = [{name:data.STATUS == "2" ? "거래가능" :'예약중', style:null},{name:'거래완료', style:null},{name:'게시글 수정', style:null},{name:'삭제', style:styles.pointColor}];
    const buttonFilter = (idx) => {
        if(idx === 0 && (data.STATUS !== '1' && data.STATUS !== '2')) { return false; }
        if(idx === 1 && (data.STATUS !== '1' && data.STATUS !== '2')) { return false; }
        return true;
    }
    /* =============== 게시글 버튼목록 =============== */
    
	return (
		<BottomSheet open={isOpen} onDismiss={(e) => { props.onDismiss("update", false) }}
			className={'bottomsheetContainer'}
			snapPoints={({ minHeight }) => minHeight}
            skipInitialTransition={false} scrollLocking={true} expandOnContentDrag={true}>
			<Element tag={`div`} className={styles.bottomsheetMarketUpdateButtonContainer}>
				<Element tag={`ul`}>
                    {buttonList.map((item, idx) => 
                        (buttonFilter(idx) ? 
                            <Element tag={`li`} key={idx} className={item.style} anyprop={(e) => {props.onDismiss("update", false); idx === 0 || idx === 3 ? marketUpdateAndDeleteAPI((idx === 0 ? (item.name == "거래가능" ? "1": item.name == "예약중" ? "2" : null) : idx === 3 ? "3" : null), data) : idx === 2 ? navigator(`/market/update/${params.seq}`, {state:data}) : props.onDismiss("success", true)}}><Element tag={`span`}>{item.name}</Element></Element>
                        : null)
                    )}
                </Element>
			</Element>
		</BottomSheet>
	)
}